import {Case} from '../../../beans/Case';
import {Nomenclature} from '../../../beans/Nomenclature';
import {FrxBaseBean} from '../../../beans/frxbasebean';
import {Payment} from '../../../beans/payment';
import {BlockUiService} from '../../../services/blockui.service';
import {CaseService} from '../../../services/case.service';
import {NomenclatureService} from '../../../services/nomenclature.service';
import {EditCaseComponent} from '../edit-case.component';
import {Component, OnInit, ViewContainerRef, Host, Input} from '@angular/core';

@Component({
	selector: 'app-edit-case-raznoski',
	templateUrl: './edit-case-raznoski.component.html',
	styleUrls: ['./edit-case-raznoski.component.scss']
})
export class EditCaseRaznoskiComponent implements OnInit {

	private _caseid;

	amount: number;
	note: string;
	paymentGround: Nomenclature;

	paymentGrounds: Array<Nomenclature>;


	oldPayments: Array<Payment> = new Array();
	totalAmount: number;

	public cols = [
		{title: 'Дата', name: 'createdDate', dataType: 'date'},
		{title: 'Основание', name: 'paymentGround', dataType: 'object', complexDataType: {object: true, displayValue: 'name'}},
		{title: 'Бележка', name: 'note'},
		{title: 'Сума', name: 'amount', dataType: 'currency'},
		{title: 'Потребител', name: 'createdBy'},
	];

	constructor(
		private caseService: CaseService,
		private damageService: NomenclatureService,
		private blockUi: BlockUiService,
		private vcRef: ViewContainerRef,
		@Host() private parentComp: EditCaseComponent, ) {}

	ngOnInit() {
		this.loadNomenclatures();
		this.loadTable();
	}

	loadTable() {
		this.blockUi.start(this.vcRef);
		this.oldPayments = new Array<Payment>();
		this.caseService.getPayments(this._caseid).subscribe(
			notes => {
				this.oldPayments = notes;
				this.totalAmount = 0;
				this.oldPayments.forEach(pa => {this.totalAmount = this.totalAmount + pa.amount;});
				this.blockUi.stop();
			},
			error => {
				this.blockUi.stop();
			});
	}


	public delete(obj) {
		if (confirm('Сигурни ли сте, че искате да изтриете плащането?')) {
			this.blockUi.start(this.vcRef);
			this.caseService.deletePayment(obj.id).subscribe(
				result => {
					this.loadTable();
					this.blockUi.stop();
				},
				error => {
					this.blockUi.stop();
				});
		}
	}

	@Input()
	public set editedCase(val: Case) {
		this.edit(val);
	}

	private refresh() {
		this.amount = null;
		this.note = null;
		this.paymentGround = null;
	}

	private edit(caseObj: Case): void {
		this.refresh();
		if (caseObj && caseObj.id) {
			this._caseid = caseObj.id;
		}
	}

	private loadNomenclatures() {
		this.loadPaymentGrounds();
	}

	private loadPaymentGrounds() {
		this.blockUi.start(this.vcRef);
		this.paymentGrounds = new Array<Nomenclature>();
		this.damageService.getPaymentGrounds().subscribe(paymentGrounds => {
			this.paymentGrounds = paymentGrounds;
			this.blockUi.stop();
		},
			error => {
				this.blockUi.stop();
			});
	}

	public addPayment() {
		const obj = new Payment();
		obj.amount = this.amount;
		obj.note = this.note;
		obj.paymentGround = this.paymentGround;
		this.blockUi.start(this.vcRef);
		this.caseService.addPayment(obj, this._caseid).subscribe(
			result => {
				this.blockUi.stop();
				alert('Плащането беше създадено');
				this.refresh();
				this.loadTable();
			},
			error => {
				alert('Възникна Грешка');
				this.blockUi.stop();
			});
	}

	// TODO: This should be in a separate service.. not copy-pasted in each component.... too lazy, don't care
	compareFrxObjects(o1: FrxBaseBean, o2: FrxBaseBean) {
		if (o1 && o2) {
			return o1.id === o2.id;
		}
	}


}
